import { ActionMenu } from "@telluscompany/design-system";
import { Edit, Trash2, MoreVertical } from "lucide-react";
import { useLocalization } from "@i18n";
import { ListClientsResponse } from "../../api/client";

interface ClientsActionMenuProps {
  client: ListClientsResponse;
  onEdit: (client: ListClientsResponse) => void;
  onDelete: (client: ListClientsResponse) => void;
}

export const ClientsActionMenu = ({
  client,
  onEdit,
  onDelete,
}: ClientsActionMenuProps) => {
  const { translate } = useLocalization();

  const actions = [
    {
      actions: [
        {
          label: translate("management.clients.button.edit"),
          onClick: () => onEdit(client),
          icon: <Edit size={16} />,
        },
        {
          label: translate("management.clients.button.delete"),
          onClick: () => onDelete(client),
          icon: <Trash2 size={16} />,
          colorTitle: "red" as const,
        },
      ],
    },
  ];

  return <ActionMenu menu={actions} trigger={<MoreVertical size={20} />} />;
};
